import axios from "axios";
import { Configuration } from "typescript-axios";
import cookie from "cookie"; // eslint-disable-line
import { getAccessToken } from "src/authUtils";

export const API_URL = import.meta.env.VITE_API_HOST;

export function getAxiosParams(basePath = API_URL) {
  return new Configuration({ basePath });
}

const RESPONSE_TIMEOUT = 15000;
const REQUEST_TIMEOUT = 15000;

if (typeof window !== 'undefined') {
  axios.interceptors.response.use(
    (response) => {
      if (
        (
          response.config.url?.includes("/api/v1/auth")
          // || response.config.url?.includes("/api/v1/users/join")
        ) &&
        response.status === 200
      ) {
        if (response.data.token) {
          document.cookie = cookie.serialize("token", response.data.token, {
            path: "/", // make it accessible from all pages
            maxAge: 60 * 60 * 24 * 29, // 29 days
          });
        }
        if (response.data.is_user_created) {
          document.cookie = cookie.serialize("isUserCreated", response.data.is_user_created, {
            path: "/", // make it accessible from all pages
            maxAge: 60 * 60 * 24 * 1, // 1 days
          });
        }
      }
      return response;
    },
    (error) => {
      if (error.code === "ECONNABORTED") {
        // maybe we should just ignore in Sentry?
        return new Promise(() => { });
      }
      return Promise.reject(error); // Any other error should be handled
    }
  );
  axios.interceptors.request.use((config) => {
    config.timeout = RESPONSE_TIMEOUT;
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return { ...config, signal: AbortSignal.timeout(REQUEST_TIMEOUT) };
  });
}

export default axios;
